import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Calendar from '../../../../components/featured/Calendar/Calendar';
import ActivityTab from '../../../../components/shared/CustomDashboard/ActivityTab/ActivityTab';
import AccountColumn from '../../../../components/shared/CustomDashboard/Overview/AccountColumn';
import ActivityColumn from '../../../../components/shared/CustomDashboard/Overview/Activity/ActivityColumn';
import DashboardDealCard from '../../../../components/shared/CustomDashboard/Overview/DashboardDealCard';
import OverviewTab from '../../../../components/shared/CustomDashboard/Overview/OverviewTab';
import TaskColumn from '../../../../components/shared/CustomDashboard/Overview/Tasks/TaskColumn';
import TodaysMeeting from '../../../../components/shared/CustomDashboard/Overview/TodaysMeeting';
import TaskTab from '../../../../components/shared/CustomDashboard/TaskTab/TaskTab';
import CustomHomepage from '../../../../components/shared/CustomHomePage/CustomHomepage';
import formatCurrency from '../../../../helper/short-currency';
import { DashboardService } from '../../../../service/dashboard.service';
import zeplinColor from '../../../../theme/Color';
import { Constants } from '../../../../utilities/constants';
type SportsProps = {
  link: '';
  title: '';
  source: '';
};

export const Homepage = () => {
  const userName = sessionStorage.getItem('user-name') || '';
  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';
  const currentTab = sessionStorage.getItem('currentTab') || '0';
  const sf_path = sessionStorage.getItem('sf_path') || '';

  const today = new Date();
  const navigate = useNavigate();
  const formattedDate = today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  const [value, setValue] = React.useState(0);
  const [alert, setAlert] = React.useState('');
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentTab', newValue.toString());
    setValue(newValue);
  };

  const handleClose = () => {
    setAlert('');
  };

  const [data, setData] = React.useState<any>();
  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);

  const getDeal = async () => {
    try {
      const res = await DashboardService.getDeal();

      setData(res);
    } catch (err: any) {
      console.log(err, 'errdeal');
      setAlert(err?.message as string);
    }
  };
  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();
      console.log(res);
      setSportsData(res?.latestNews);
    } catch (err: any) {
      console.log(err, 'errsports');
      setAlert(`Something went wrong fetching news data`);
    }
  };
  React.useEffect(() => {
    getDeal();
    getSportNews();

    sf_redirect === 'Task' && setValue(2);
    sf_redirect === 'Overview' && setValue(0);
    sf_redirect === 'Activity' && setValue(1);
    sf_path && navigate(sf_path);
    if (!sf_redirect && !sf_path && currentTab) {
      setValue(+currentTab || 0);
    }
  }, []);

  const DashboardTabs = [
    {
      label: 'Overview',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <OverviewTab
            setActiveTab={setValue}
            Column1={ActivityColumn}
            Column2={TaskColumn}
            Column3={AccountColumn}
            Column4={TodaysMeeting}
            setValue={setValue}
            path={'/clients'}
          />
        </Box>
      ),
    },
    {
      label: 'Activity',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ActivityTab />
        </Box>
      ),
    },
    {
      label: 'Task',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <TaskTab />
        </Box>
      ),
    },
    {
      label: 'Calendar',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <Calendar />
        </Box>
      ),
    },
  ];
  return (
    <CustomHomepage
      sportsData={sportsData}
      ProfileDetails={
        <Box>
          <Typography
            sx={{
              fontSize: { xs: '24px', xl: '36px' },
              fontWeight: 300,
              color: zeplinColor.Neutral1,
            }}
          >
            Hello, {userName}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src='/assets/calendar-fade.svg' width={18} height={18} alt='calendar fade' />
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral6}>
              {formattedDate}
            </Typography>
          </Box>
        </Box>
      }
      DealCard={
        <Box sx={{ display: 'flex', gap: '16px', flex: 1 }}>
          <DashboardDealCard
            color={Constants.DealsColor.totalDealsWon}
            val={
              +data?.totalDealsWon >= 0 ? `$${formatCurrency(data?.totalDealsWon) ?? 0}` : undefined
            }
            percent={data?.dealsWonDelta || 0}
            text={Constants.DealsText.totalDealsWon}
          />

          <DashboardDealCard
            color={Constants.DealsColor.totalOpenDeals}
            val={
              +data?.totalOpenDeals >= 0
                ? `$${formatCurrency(data?.totalOpenDeals) ?? 0}`
                : undefined
            }
            percent={data?.openDealsDelta || 0}
            text={Constants.DealsText.totalOpenDeals}
          />

          <DashboardDealCard
            color={Constants.DealsColor.quaterly}
            val={
              +data?.quarterRevenue >= 0
                ? `$${formatCurrency(data?.quarterRevenue) ?? 0}`
                : undefined
            }
            percent={data?.dealsWonDelta || 0}
            text={Constants.DealsText.quaterly}
          />

          <DashboardDealCard
            color={Constants.DealsColor.totalTasks}
            val={data?.totalTasks}
            text={Constants.DealsText.totalTasks}
          />
        </Box>
      }
      DashboardTabs={DashboardTabs}
      handleChange={handleChange}
      value={value}
      alert={alert}
      handleClose={handleClose}
    />
  );
};

export default Homepage;
